import { render, staticRenderFns } from "./EditCacaoTreeData.vue?vue&type=template&id=2e4dcf3d"
import script from "./EditCacaoTreeData.vue?vue&type=script&lang=js"
export * from "./EditCacaoTreeData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports